import { DigitsValidatorConfig, ValdrValidator } from '@app/valdr/models';
import { hasNoValue, isValidNumber } from '@app/valdr/util';
import { stringLengthValidator } from '@app/valdr/validators/length-validator';
import * as R from 'ramda';

// matches everything except digits and '.' as decimal separator
const regexp = new RegExp('[^.\\d]', 'g');

/*
* By converting to number and back to string using toString(), we make sure that '.' is used as decimal separator
* and not the locale specific decimal separator.
* As we already checked for NaN at this point, we can do this safely.
* */
const toStringWithoutThousandSeparators = value =>
  Number(value).toString().replace(regexp, '');

const doValidate = ({integer: integerConstraint, fraction: fractionConstraint}, value) => {
  const cleanValueAsString = toStringWithoutThousandSeparators(value);
  const [integer, fraction] = cleanValueAsString.split('.');

  return stringLengthValidator(R.gte(integerConstraint), integer)
    && stringLengthValidator(R.gte(fractionConstraint), fraction);
};

export const digitsValidator: ValdrValidator = R.curry((config: DigitsValidatorConfig, value: any) => {
  if (hasNoValue(value)) {
    return true;
  }

  if (!isValidNumber(Number(value))) {
    return false;
  }

  return doValidate(config, value);
});
